interface BlogAuthorProfileProps {
  author: string;
  role: string;
}

export default function BlogAuthorProfile({ author, role }: BlogAuthorProfileProps) {
  return (
    <div className="border-t border-background-200/60 pt-8 mt-10">
      <div className="flex items-start gap-4">
        {/* Author Avatar */}
        <div className="w-14 h-14 rounded-full bg-primary-900 flex items-center justify-center flex-shrink-0 overflow-hidden">
          <i className="ri-user-3-line text-xl text-foreground-400"></i>
        </div>
        <div>
          <p className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] mb-1">
            {author}
          </p>
          <p className="text-[14px] text-foreground-500 tracking-[0.04em] mb-2">
            {role}
          </p>
          <p className="text-[15px] text-foreground-600 leading-relaxed tracking-[0.03em]">
            英国式執事教育と日本のおもてなし文化の両方に精通する現役の執事教育者。
            全日本執事協会が監修する教科書『E1 執事学入門：歴史・文化・職業倫理』の編著者の一人。
          </p>
        </div>
      </div>
    </div>
  );
}